import React from 'react';
import classNames from 'classnames';

import './price.scss';

const Price: React.FC<{
    price: number;
    color?: 'primary' | 'secondary' | 'red' | 'green' | 'white' | 'text-primary' | 'text-secondary';
    weight?: 400 | 500 | 600;
    fontSize?: 10 | 12 | 14 | 16 | 18 | 21 | 24;
    crossed?: boolean;
    className?: string;
}> = ({
    price,
    color = '',
    weight = '500',
    fontSize = 16,
    crossed,
    className
}) => {
    const [priceInteger, priceFractional]: string[] = parseFloat(String(price)).toFixed(2).split('.');

    if (!price) {
        return null;
    }

    return (
        <span
            className={classNames({
                'price': true,
                [`price--${color}`]: Boolean(color),
                [`price--fw-${weight}`]: Boolean(weight),
                [`price--fs-${fontSize}`]: Boolean(fontSize),
                'price-crossed': Boolean(crossed),
                [String(className)]: Boolean(className)
            })}
        >
            {priceInteger.replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ')}
            {`,${priceFractional} zł`}
        </span>
    );
};

export default Price;
